module.exports = {
	"customer": "ลูกค้า",
	"customerEdit": "จัดการลูกค้า",
	"create": "เพิ่มลูกค้า",
	"refCode": "รหัสลูกค้า",
	"name": "ชื่อลูกค้า",
	"namePlaceholder": "กรุณาใส่ชื่อลูกค้า",
	"phoneNumber": "เบอร์โทรศัพท์",
	"email": "อี-เมล",
	"address": "ที่อยู่",
	"addAddress": "เพิ่มที่อยู่",
	"type": "ประเภท",
	"image": "รูปภาพ",
	"addressName": "ชื่อสถานที่",
	"birthday": "วันเกิด",
	"lineId": "Line ID",
	"province": "จังหวัด",
	"district": "เขต/อำเภอ",
	"subDistrict": "แขวง/ตำบล",
	"zipCode": "รหัสไปรษณีย์",
	"country": "ประเทศ",
	"category": "ประเภทลูกค้า",
	"group": "กลุ่มลูกค้า",
	"addGroup": "สร้างกลุ่มลูกค้า",
	"groupName": "ชื่อกลุ่ม",
	"bankName": "ชื่อธนาคาร",
	"bankNumber": "เลขที่บัญชี",
	"bankOwnerName": "ชื่อบัญชี",
	"bankInfo": "เลขที่บัญชี สำหรับโอนค่ามัดจำคืน",
	"deleteConfirmText": "ทำการลบลูกค้า/คู่ค้า"
};


//////////////////
// WEBPACK FOOTER
// ./src/locale/th/customer.json
// module id = 836
// module chunks = 1